const FA = '۰۱۲۳۴۵۶۷۸۹';
const AR = '٠١٢٣٤٥٦٧٨٩';

export const toLatinDigits = (str) =>
    String(str ?? '')
        .replace(/[۰-۹]/g, (c) => FA.indexOf(c))
        .replace(/[٠-٩]/g, (c) => AR.indexOf(c))
        .replace(/٫/g, '.')
        .replace(/٬/g, ',');

const setNativeValue = (el, value) => {
    const proto = el instanceof HTMLTextAreaElement
        ? HTMLTextAreaElement.prototype
        : HTMLInputElement.prototype;
    Object.getOwnPropertyDescriptor(proto, 'value').set.call(el, value);
};

const isNumericField = (el) =>
    el instanceof HTMLInputElement &&
    (['numeric', 'decimal', 'tel'].includes(el.inputMode) ||
        el.type === 'tel' ||
        el.dataset.digits === 'en');

export function installLatinDigits() {
    document.addEventListener(
        'input',
        (e) => {
            const el = e.target;
            if (e.isComposing || !isNumericField(el)) return;

            const oldValue = el.value;
            const newValue = toLatinDigits(oldValue);
            if (newValue === oldValue) return;

            let start = null, end = null;
            try { start = el.selectionStart; end = el.selectionEnd; } catch (err) {}

            setNativeValue(el, newValue);

            try {
                if (start !== null) el.setSelectionRange(start, end);
            } catch (err) {}
        },
        true // capture: قبل از onChange ری‌اکت اجرا می‌شود
    );
}